// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-14"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 4.6L12 3L8 4.6V21H16V4.6Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M22 21V9H16V21H22Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M2 21H8V9H2V21Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 21V16M22 9V21H16V9H22ZM8 21H2V9H8V21ZM12 7.99805H12.0039V8.00195H12V7.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5.1V21H8V5.1M17 5L12 3L7 5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const City14Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-14',
    ref,
    icon: element,
  },
));

City14Icon.displayName = 'City14Icon';

export default City14Icon;
